export function formatFoldCost(washRequest) {
  if (washRequest.fold_weight_point <= 0) {
    return '';
  }
  const weightPoint = washRequest.fold_weight_point.toFixed(1);
  return `${weightPoint}／${washRequest.total_fold_cost_minutes}分`;
}

export const ONETIME_MAX_COUNT = 20;
export const PICKUP_MAX_COUNT = 20;
